var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineVector = function SvgLineVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 509,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 507.113c290 0 390.442-20.089 665-348.314 353.2-422.243 635 137.156 775 181.156",
    stroke: "#2B3038",
    strokeOpacity: 0.3,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgLineVector as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI1MDkiIHZpZXdCb3g9IjAgMCAxNDQwIDUwOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNTA3LjExM0MyOTAgNTA3LjExMyAzOTAuNDQyIDQ4Ny4wMjQgNjY1IDE1OC43OTlDMTAxOC4yIC0yNjMuNDQ0IDEzMDAgMjk1Ljk1NSAxNDQwIDMzOS45NTUiIHN0cm9rZT0iIzJCMzAzOCIgc3Ryb2tlLW9wYWNpdHk9IjAuMyIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";